var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"on-clickout",rawName:"v-on-clickout",value:(_vm.closeToggle),expression:"closeToggle"}]},[_c('div',{staticClass:"side-dots",on:{"click":_vm.openToggle}},[_vm._v("⋮")]),(_vm.open)?_c('div',{staticClass:"drop-side"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }